export const all_routes = {
  //region icons
  fontawesome: "/icon-fontawesome",
  feathericon: "/icon-feather",
  ionicicons: "/icon-ionic",
  materialicons: "/icon-material",
  pe7icons: "/icon-pe7",
  simpleline: "/icon-simpleline",
  themifyicons: "/icon-themify",
  iconweather: "/icon-weather",
  typicons: "/icon-typicon",
  flagicons: "/icon-flag",
  remixIcon: "/remix-icon",
  BootstrapIcon: "/bootstrap-icon",
  TablerIcon: "/tabler-icon",

  //region auth
  signin: "/signin",
  signinTwo: "/singintwo",
  singinThree: "/signinThree",
  forgotPassword: "/forgot-password",

  //region layput demo
  Horizontal: "/layout-horizontal",
  Detached: "/layout-detached",
  Hovered: "/layout-hovered",
  Boxed: "/layout-box",
  Modern: "/layout-modern",
  TwoColumn: "/layout-two-column",
  Dark: "/layout-dark",
  RTL: "/layout-rtl",

  //region CRM
  crmdashboard: "/crm/dashboard",
  crmcustomers: "/crm/customers",
  crmcontacts: "/crm/contacts",
  crminvoices: "crm/invoices",
  crmtasks: "/crm/tasks",
  crmestimates: "/crm/estimates",
  crmcreatenewestimate: "/crm/createnewestimate",
  crmsalesproposals: "/crm/proposals",
  crmcreateproposal: "/crm/newproposal",
  crmeditproposal: "/crm/editproposal/:id",
  crmviewproposal: "/crm/viewproposal/:id",
  crmeditestimate: "/crm/editestimate/:id",
  crmviewestimate: "/crm/viewestimate",
  crmnewinvoice: "/crm/newinvoice",
  crmeditinvoice: "/crm/editinvoice",
  crmexpenses: "/crm/expenses",
  crmproposalinfo: "/crm/proposalinfo/:id",
  crmestimateinfo: "/crm/estimateinfo/:id",
  crmexpenseinfo: "/crm/expenseinfo",
  crmpayments: "/crm/payments",
  crmviewpayments: "/crm/viewpayments",
  crmcreditnotes: "/crm/creditnotes",
  crmnewcreditnote: "/crm/newcreditnote",
  crmcreditnoteinfo: "/crm/creditnoteinfo/:id",
  crmcreditnoteedit: "/crm/creditnoteedit/:id",
  crmleads: "/crm/leads",
  crmtickets: "/crm/tickets",
  crmviewleads: "/crm/viewleads/:id",
  crmcustomerinfo: "/crm/customerinfo/:id",
  crmnewticket: "/crm/newticket",
  crmprojects: "/crm/projects",
  crmproducts: "/crm/products",
  crmviewinvoice: "/crm/viewinvoice",
  crmeditexpenses: "/crm/editexpenses",
  projectView: "/crm/projectview/:id",
  Add: "/crm/add/:type",
  View: "/crm/view/:type",
  Update: "/crm/update/:type/:id",
  reports: "/crm/reports/:reportId",
  crmnotifications: "/crm/Notifications",
  queries: "/crm/queries",
  campaign: "/crm/campaign",
  crmmessagehub: "/crm/Messages",
};
